import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { createStackNavigator } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/native';
import i18n from 'i18n-js';
import * as Browser from '@sentry/react';

import Login from '../screens/Login'
import QRCodeLogin from '../screens/QRCodeLogin';
import Header from "../components/basic/Header";
import Agb from '../screens/Agb';

import { backendSync, backendTokenLogin } from '../stores/thunks';
import SideNavigationDrawer from "./SideNavigationDrawer";
import ModalMessage from "../screens/modals/ModalMessage";
import ModalResetPW from '../screens/modals/ModalResetPW';
import ModalDemo from '../screens/modals/ModalDemo';
import { InteractionManager } from 'react-native';
import { switchScreen } from '../hooks/navigate';
import { wsSend } from "../stores/mainSlice";

const mainStack = createStackNavigator()

export default function Main() {
  const settings = useSelector((state) => state.settings)

  const server = useSelector((state) => state.server)
  const user = useSelector((state) => state.user)
  const message = useSelector((state) => state.temp.msg)
  const dispatch = useDispatch()

  const navigation = useNavigation()

  useEffect(() => {

  }, []);

  useEffect(() => {
    console.ina('SIGNEDIN', user)
    if (user.isSignedIn) {
      // TODO: Check with new Sentry integration
      Browser.setUser({
        id: user.id,
        name: user.preferredName,
        email: user.mail
      })
      if (!user.demo) {
        dispatch(wsSend({ msg: { type: 'USER', receivers: [], data: null } }))
        if (server?.token?.value) { //  && !(server.online && server.login && Date.now() - server.login < 60 * 60000)
          dispatch(backendTokenLogin('ONLINE'))
        }
      }
    }
  }, [user.isSignedIn])

  useEffect(() => {
    if (message) {
      switchScreen(navigation, 'ModalMessage', { message: message })
    }
  }, [message])

  useEffect(() => {
    let syncInterval = null
    if (server.online) {
      console.ina("SYNC BEG", JSON.stringify(server.sync, null, 2))
      // start the regular check for sync to be done
      syncInterval = setInterval(() => {
        InteractionManager.runAfterInteractions(() => {
          // console.ina('RUN Sync')
          dispatch(backendSync())
        });

      }, 10000)
    } else {
      if (syncInterval) {
        console.ina("SYNC END")
        clearInterval(syncInterval)
        syncInterval = null
      }
    }
    return function cleanup() {
      if (syncInterval) {
        console.ina("SYNC FIN")
        clearInterval(syncInterval)
        syncInterval = null
      }
    }
  }, [server.online])

  const verticalAnimation = {
    headerShown: true,
    header: (props) => <Header {...props} />,
    presentation: 'modal',
    gestureEnabled: true,
    gestureDirection: 'vertical',
    cardStyleInterpolator: ({ current, layouts }) => {
      // console.ina("vertival")
      return {
        cardStyle: {
          transform: [
            {
              translateY: current.progress.interpolate({
                inputRange: [0, 1],
                outputRange: [layouts.screen.height, 0],
              }),
            },
          ],
        },
      }
    },
  }

  return (settings.showTOU || settings.showDPA) ? (
    <mainStack.Navigator initialRouteName='Agb' screenOptions={verticalAnimation}>
      <mainStack.Screen name='Agb' component={Agb} options={{ title: i18n.t(settings.showTOU ? 'tou.header' : 'dpa.header'), info: i18n.t(settings.showTOU ? 'tou.info' : 'dpa.info'), hidePhone: true }} />
    </mainStack.Navigator>
  ) : (
    user.isSignedIn ? (
      <SideNavigationDrawer />
    ) : (
      <mainStack.Navigator initialRouteName='Login' screenOptions={verticalAnimation}>
        <mainStack.Screen name='Login' component={Login} options={{ headerShown: false }} />
        <mainStack.Screen name='ModalResetPW' component={ModalResetPW} options={{ headerShown: false, presentation: 'transparentModal' }} />
        <mainStack.Screen name='ModalDemo' component={ModalDemo} options={{ headerShown: false, presentation: 'transparentModal' }} />
        <mainStack.Screen name='QRCodeLogin' component={QRCodeLogin} options={{ title: i18n.t('login.title'), info: i18n.t('login.info') }} />
        <mainStack.Screen name='ModalMessage' options={{ title: i18n.t('message.info') }} >
          {(props) => <ModalMessage  {...props} message={message} />}
        </mainStack.Screen>
      </mainStack.Navigator>)
  )
}
